import { render, staticRenderFns } from "./StaffIndividualLeaveEntitlementPage.vue?vue&type=template&id=19d838f0&scoped=true&"
import script from "./StaffIndividualLeaveEntitlementPage.vue?vue&type=script&lang=js&"
export * from "./StaffIndividualLeaveEntitlementPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d838f0",
  null
  
)

export default component.exports